import React from 'react';
import { useFirebase } from '../../providers/FirebaseProvider';

const StatusBar: React.FC = () => {
  const { user } = useFirebase();
  
  return (
      <div className="max-w-7xl mx-auto flex justify-center items-center mt-4">
        <div className="text-sm text-muted-foreground">
          {user && (
            <span>Signed in as {user.email}</span>
          )}
        </div>
    </div>
  );
};

export default StatusBar;
